export const ADD_ATTRIBUTE = "ADD_ATTRIBUTE";

export const PREFIX_FOR_FIELDS = "product_";

export const EVENT_NAVIGATION = "NAVIGATION_EVENT";

export const CODING_TASK_ROLES = [
    "coding.standard.detailed.a",
    "coding.standard.detailed.b",
    "coding.standard.detailed",
    "coding.standard.b",
    "coding.standard.a",
];

export const BRAND_VERIFIED_ATTR_GROUPS = {
    "coding.standard.a": "BrandVerifiedCodingStandardAttributes",
    "coding.standard.b": "BrandVerifiedCodingStandardAttributes",
    "coding.standard.detailed.a": "BrandVerifiedCodingDetailedAttributes",
    "coding.standard.detailed.b": "BrandVerifiedCodingDetailedAttributes",
};

export const BRAND_VERIFIED_SHORT_ATTR_LIST = {
    standard: "BrandVerifiedCodingStandardAttributes",
    detailed: "BrandVerifiedCodingDetailedAttributes",
};
